
const messages = {
    en: {
       delivery: {
          stock: {
            name: 'Stock',
            title: 'Stock management',
            subtitle: 'View, search, create, edit and delete Stock',
            creating: 'Creating Stock',
            editing: 'Editing Stock',
            deleting: 'Deleting Stock',
            showing: 'Showing Stock',
            menu: 'Stock',
            labels: {
                branch: 'Branch',
                items: 'Items',
                product: 'Product',
                quantity: 'Quantity',
                order: 'Order',
                hide: 'Hide',
                minimum: 'Minimum'
            },

          }
       }
    },
    es: {
       delivery: {
          stock: {
            name: 'Stock',
            title: 'Administración de Stock',
            subtitle: 'Ver, buscar, crear, editar, y borrar Stock',
            creating: 'Creando Stock',
            editing: 'Modificando Stock',
            deleting: 'Eliminando Stock',
            showing: 'Detalles de Stock',
            menu: 'Stock',
            labels: {
                branch: 'Sucursal',
                items: 'Artículos',
                product: 'Producto',
                quantity: 'Cantidad',
                order: 'Orden',
                hide: 'Ocultar',
                minimum: 'Mínimo'
            },

          }
       }
    },
    pt: {
       delivery: {
          stock: {
            name: 'Stock',
            title: 'Administração de Stock',
            subtitle: 'Ver, buscar, criar, editar e usar Stock',
            creating: 'Criando Stock',
            editing: 'Edição Stock',
            deleting: 'Apagando Stock',
            showing: 'Detalhes do Stock',
            menu: 'Stock',
            labels: {
                branch: 'Sucursal',
                items: 'Items',
                product: 'Product',
                quantity: 'Quantity',
                order: 'Order',
                hide: 'Hide',
                minimum: 'minimum'
            },

          }
       }
    }
}

export default messages
